import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';

import { Appointment } from '../appointment';
import { Patient } from '../../patient/patient';
import { Prescription } from '../../prescription/prescription';
import { ExamRequest } from '../../exam/exam-request';

import { AppointmentService } from '../../service/appointment.service';
import { PatientService } from '../../service/patient.service';
import { PrescriptionService } from '../../service/prescription.service';
import { ExamRequestService } from '../../service/exam-request.service';

declare var jQuery: any;

@Component({
  selector: 'mc-appointment-index',
  templateUrl: './appointment-index.component.html',
  styleUrls: ['./appointment-index.component.scss']
})
export class AppointmentIndexComponent implements OnInit {

  @ViewChild('createNewModal', { static: true }) private createNewModal: ElementRef;
  public appointments: Appointment[];
  public patient: Patient;
  public prescriptions: Prescription[];
  public exams: ExamRequest[];

  constructor(
    private appointmentService: AppointmentService,
    private patientService: PatientService,
    private prescriptionService: PrescriptionService,
    private examRequestService: ExamRequestService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    this.getPatient(id);
    this.getPrescriptions(id);
    this.getExamRequests(id);
    this.getAppointments(id);
  }

  getPatient(id: number): void {
    this.patientService.getPatient(id).subscribe(patient => this.patient = patient);
  }

  getPrescriptions(patientId: number): void {
    this.prescriptionService.searchPrescriptionsByPatientId(patientId).subscribe(
      prescriptions => this.prescriptions = prescriptions
    );
  }

  getExamRequests(patientId: number): void {
    this.examRequestService.searchExamRequestsByPatientId(patientId).subscribe(
      requests => this.exams = requests
    );
  }

  getAppointments(patientId: number): void {
    this.appointmentService.searchAppointmentByPatientId(patientId).subscribe(
      appointments => {
        this.appointments = appointments;
        if (appointments.length < 1) {
          // TODO: I think this should go to the html with an *ngIf
          jQuery(this.createNewModal.nativeElement).modal('show');
        }
      }
    );
  }

  goBack(): void {
    this.location.back();
  }

  createNew(): void {
    this.router.navigate([`paciente/${this.patient.id}/atendimento/novo`]);
  }
}
